import React from "react";

import { useTranslation } from "utils";

import { Collapse, Icon, Typography } from "components";

const DATA_LAYERS = [
  { key: "regionalSoil", iconName: "klim/crops-emerging" },
  { key: "climateZone", iconName: "tabler/cloud" },
  { key: "regionalYields", iconName: "klim/field" },
  { key: "cropRotation", iconName: "klim/crop-rotation" },
] as const;

// Expandable "How are the forecasts calculated?" banner: chip summary collapsed, one card
// per data layer when expanded.
export const ForecastExplainerBanner = () => {
  const { t } = useTranslation("scenarioAnalysis");

  const header = (
    <div className="onboarding-explainer__header">
      <Typography variant="paragraph-m">{t("onboarding.explainer.title")}</Typography>
      <Typography variant="paragraph-s" color="grey-600">
        {t("onboarding.explainer.subtitle")}
      </Typography>
      <div className="onboarding-explainer__chips">
        {DATA_LAYERS.map((layer) => (
          <span key={layer.key} className="onboarding-explainer__chip">
            {t(`onboarding.explainer.${layer.key}.title`)}
          </span>
        ))}
      </div>
    </div>
  );

  const items = [
    {
      key: "explainer",
      label: header,
      children: (
        <div className="onboarding-explainer__cards">
          {DATA_LAYERS.map((layer) => (
            <div key={layer.key} className="onboarding-explainer__card">
              <span className="onboarding-explainer__card-icon">
                <Icon iconName={layer.iconName} size="m-light" />
              </span>
              <div className="onboarding-explainer__card-text">
                <Typography variant="h6">{t(`onboarding.explainer.${layer.key}.title`)}</Typography>
                <Typography variant="paragraph-s" color="grey-600">
                  {t(`onboarding.explainer.${layer.key}.description`)}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      ),
    },
  ];

  return <Collapse className="onboarding-explainer" items={items} />;
};
